import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import PaiButton from 'features/ui/base-components/pai-button';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import PaiLink from '../base-components/pai-link';

interface Props {
  open: boolean;
  title: string;
  confirmButton: string;
  cancelButton?: string;
  loading?: boolean;
  disableCancelButton?: boolean;
  children?: React.ReactNode;

  handleClose?(): void;

  handleConfirm?(values: any): void | any;
}

const BasicConfirmDialog: React.FC<Props> = ({
  open,
  title,
  confirmButton,
  loading,
  disableCancelButton,
  cancelButton,
  handleClose,
  handleConfirm,
  children,
}) => {
  const { classes } = useStyles();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{title}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>{children}</DialogContent>
      <DialogActions className={classes.actions}>
        {!disableCancelButton && cancelButton ? <PaiLink text={cancelButton} size={'sm'} underline={'always'} action={handleClose} /> : null}
        <PaiButton text={confirmButton} action={handleConfirm} disabled={loading} loading={loading} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  title: {
    background: theme.palette.warning.main,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default BasicConfirmDialog;
